export const ADD_SAVED_PRODUCT = "ADD_SAVED_PRODUCT";
export const REMOVE_SAVED_PRODUCT = "REMOVE_SAVED_PRODUCT";
